import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Push Notification',
  path: '/homenet/pushnotification',
  redirect: '/homenet/pushnotification/state',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'pushnotification state',
      'path': 'state',
      'meta': {
        'label': 'state'
      },
      'component': lazyLoading('homenet/PushNotification')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/pushnotification.js